export default "__VITE_ASSET__CE$KzaW6__"